import { render, staticRenderFns } from "./BimTransparencyArea.vue?vue&type=template&id=0f3c33d6"
import script from "./BimTransparencyArea.vue?vue&type=script&lang=js"
export * from "./BimTransparencyArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports